<template>
  <div id="contact">
    <v-card
      class="mx-auto mb-10"
      max-width="600"
      min-height="650"
      elevation="20"
    >

      <v-container
        style="min-height: 600px;max-width: 600px;"
        fluid
        v-if="sending"
        fill-height
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col cols="12">
            <div class="loader mx-auto"></div>
          </v-col>
        </v-row>
      </v-container>

      <v-form
        v-if="!sent && !sending"
        ref="form"
        class="pa-10"
        style="text-align: center;"
      >
        <h1 class="mb-10">CONTACT US</h1>
        <v-text-field
          v-model="name"
          class="mb-3"
          label="FULL NAME"
          hide-details="auto"
          :rules="[v => !!v || 'Item is required']"
          required
        ></v-text-field>
        <v-text-field
          v-model="email"
          :rules="[(v) => /.+@.+\..+/.test(v) || 'E-mail must be valid']"
          class="mb-3"
          label="EMAIL"
          hide-details="auto"
          required
        ></v-text-field>
        <v-text-field
          v-model="phone"
          class="mb-3"
          label="PHONE NUMBER"
          hide-details="auto"
          :rules="[(v) => /^[0-9]*$/.test(v) || 'Phone Number must be valid']"
          required
        ></v-text-field>
        <v-textarea
          v-model="message"
          class="mb-3"
          label="MESSAGE"
          hide-details="auto"
          :rules="[v => !!v || 'Item is required']"
          required
        ></v-textarea>
        <v-btn
          @click="submit"
          color="#700000"
          style="color: white"
          class="mt-10 pa-8"
          block
        >SUBMIT</v-btn>
      </v-form>
      <v-container
        v-if="sent"
        style="min-height: 600px; max-width: 600px;"
        fill-height
        text-center
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col cols="12">
            <h1 class="mb-10 mx-auto">CONTACT US</h1>
            <p
              v-if="error"
              style="font-weight: bold"
              class="mt-4 mx-auto"
            >
              AN ERROR OCCURED WHILE SENDING EMAIL.
            </p>
            <p
              v-else
              style="font-weight: bold; max-width:500px;"
              class="mt-4 mx-auto"
            >
              THANK YOU FOR YOUR MESSAGE, WE WILL GET BACK TO YOU AS SOON AS
              POSSIBLE.
            </p>

            <v-btn
              color="#263238"
              class="pa-6 mt-6"
              style="color: white"
              @click="
                    () => {
                    sent = false;
                    error = false;
                    }
                "
            >
              SEND ANOTHER
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import apiClient from "../services/api";

export default {
  methods: {
    async submit () {
      if (this.$refs.form.validate()) {
        let loaded = await this.$recaptchaLoaded();

        if (loaded) {
          this.sending = true;

          await this.$recaptcha().then(async (token) => {
            let emailTemplate = `<!doctype html><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head><title>Contact Us - CanIT Limited.</title><!--[if !mso]><!-- --><meta http-equiv="X-UA-Compatible" content="IE=edge"><!--<![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1"><style type="text/css">#outlook a { padding:0; }
                            body { margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%; }
                            table, td { border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt; }
                            img { border:0;height:auto;line-height:100%; outline:none;text-decoration:none;-ms-interpolation-mode:bicubic; }
                            p { display:block;margin:13px 0; }</style><!--[if mso]>
                        <xml>
                        <o:OfficeDocumentSettings>
                            <o:AllowPNG/>
                            <o:PixelsPerInch>96</o:PixelsPerInch>
                        </o:OfficeDocumentSettings>
                        </xml>
                        <![endif]--><!--[if lte mso 11]>
                        <style type="text/css">
                            .mj-outlook-group-fix { width:100% !important; }
                        </style>
                        <![endif]--><style type="text/css">@media only screen and (min-width:480px) {
                        .mj-column-per-100 { width:100% !important; max-width: 100%; }
                        }</style><style type="text/css">@media only screen and (max-width:480px) {
                        table.mj-full-width-mobile { width: 100% !important; }
                        td.mj-full-width-mobile { width: auto !important; }
                        }</style></head><body style="background-color:white;"><div style="display:none;font-size:1px;color:#ffffff;line-height:1px;max-height:0px;max-width:0px;opacity:0;overflow:hidden;">Query</div><div style="background-color:white;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#E7E7E7;background-color:#E7E7E7;width:100%;"><tbody><tr><td><!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:200px;"><a href="https://www.canit.co.nz/" target="_blank"><img alt height="auto" src="https://www.canit.co.nz/img/canitLogo.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="200"></a></td></tr></tbody></table></td></tr><tr><td align="center" style="font-size:0px;padding:10px 25px;padding-top:0;word-break:break-word;"><div style="font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-size:13px;font-weight:bold;letter-spacing:1px;line-height:20px;text-align:center;text-transform:uppercase;color:#700000;"></div></td></tr><tr><td align="center" style="font-size:0px;padding:0;word-break:break-word;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;"><tbody><tr><td style="width:600px;"><a href="https://google.com" target="_blank"><img alt height="auto" src="https://images.pexels.com/photos/238118/pexels-photo-238118.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="600"></a></td></tr></tbody></table></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table><!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="body-section-outlook" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div class="body-section" style="-webkit-box-shadow: 1px 4px 11px 0px rgba(0, 0, 0, 0.15); -moz-box-shadow: 1px 4px 11px 0px rgba(0, 0, 0, 0.15); box-shadow: 1px 4px 11px 0px rgba(0, 0, 0, 0.15); margin: 0px auto; max-width: 600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0;padding-top:0;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" width="600px" ><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]--><div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;"><table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;"><tbody><tr><td style="direction:ltr;font-size:0px;padding:20px 0;padding-left:15px;padding-right:15px;text-align:center;"><!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:570px;" ><![endif]--><div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;"><table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%"><tr><td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;"><div style="font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-size:20px;font-weight:bold;line-height:24px;text-align:left;color:#212b35;"></div></td></tr><tr><td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;"><div style="font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#637381;">Name: ${this.name}<br>Email: ${this.email}<br>Phone: ${this.phone}</div></td></tr><tr><td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;"><div style="font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-size:20px;font-weight:400;line-height:24px;text-align:left;color:#700000;"><br><strong>Message</strong></div></td></tr><tr><td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;"><div style="font-family:'Helvetica Neue', Helvetica, Arial, sans-serif;font-size:16px;font-weight:400;line-height:24px;text-align:left;color:#637381;"> ${this.message} </div></td></tr></table></div><!--[if mso | IE]></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table></td></tr></table><![endif]--></td></tr></tbody></table></div><!--[if mso | IE]></td></tr></table><![endif]--></div>
                        <br><br>
                        <center> Copyright © 2021 <a style="text-decoration:none; color:#700000;" href="https://www.canit.co.nz/">CanIT Limited.</a> All Rights Reserved. </p> </center>
                        </body></html>`;

            let body = {
              emailTo: ["sales@canit.co.nz"],
              replyTo: [this.email],
              emailFrom: "Admin | CanIT Limited <sales@canit.co.nz>",
              emailHtmlBody: emailTemplate,
              emailSubject: "Contact Us - CanIT Limited.",
              emailTextBody:
                "Please view this email in a updated browser to see more details.Thank You! CanIT Limited.",
              grecaptcharesponsetoken: token,
              site: 'canit'
            };

            await apiClient.api.post("", body).then(() => {
              this.sending = false;
              this.sent = true;
            }).catch(e => {
              this.sending = false;
              this.sent = false;
              this.error = true;
              console.log(e);
            });

            this.name = "";
            this.phone = "";
            this.email = "";
            this.message = "";
            this.sent = true;
            this.sending = false;
          });
        }
      }
    },
  },
  data: () => ({
    error: false,
    sending: false,
    sent: false,
    name: '',
    email: '',
    phone: '',
    message: ''
  })
}
</script>

<style scoped>
@media only screen and (min-width: 999px) {
  .container {
    width: 1000px;
  }
}

@media only screen and (max-width: 1000px) {
  .container {
    width: 100%;
  }
}

.loader {
  border: 6px solid #f3f3f3; /* Light grey */
  border-top: 6px solid #590003; /* Blue */
  border-radius: 50%;
  width: 100px;
  height: 100px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>

